import PropTypes from 'prop-types'

/*
	It is a wrapper component.
	It accepets two paramteres. One is requiredPermissions and seconds is child component
	if required permissions machces with allowed permissions then child component is rendered otherwise not.

	How to use it:
	<AccessControl requiredPermissions={['employees:create']} >
	  <button onClick={()=> createEmployee()}> Create Employee </button>
	<AccessControl>
*/

const hasPermissions = requiredPermissions => {
	const allowedPermissionsStr = localStorage.getItem('user_permissions')
	let allowedPermissions = []
	if (allowedPermissionsStr) {
		allowedPermissions = allowedPermissionsStr.split(',')
	}
	let allowed = true
	if (requiredPermissions.length && allowedPermissions.length) {
		requiredPermissions.forEach(permission => {
			if (allowed && allowedPermissions.indexOf(permission) === -1) {
				allowed = false
			}
		})
	}
	return allowed
}

const AccessControl = ({ requiredPermissions, children }) => {
	const allowed = hasPermissions(requiredPermissions)
	return allowed ? children : null
}

AccessControl.propTypes = {
	requiredPermissions: PropTypes.array.isRequired,
	children: PropTypes.object,
}

export default AccessControl

export { hasPermissions }
